import { createColumnHelper } from '@tanstack/react-table';

/**
 * PickupsTab (the "Pending Counts" tab) has never been wired to a real
 * endpoint: CustomTable was called with data={[]} and both headerRow and
 * renderRow repeated the same literal placeholder strings. There is no row
 * type to accessor off of, so each column is a static col.display — this
 * preserves the placeholder text verbatim rather than inventing a data
 * shape that doesn't exist yet.
 */
type PlaceholderRow = Record<string, never>;

const col = createColumnHelper<PlaceholderRow>();

export const buildPendingCountsColumns = () => [
  col.display({
    id: 'id',
    header: 'ID',
    minSize: 80,
    size: 100,
    meta: { truncate: false },
    cell: () => 'ID',
  }),
  col.display({
    id: 'companyName',
    header: 'Company Name',
    minSize: 150,
    size: 200,
    meta: { truncate: false },
    cell: () => 'Company Name',
  }),
  col.display({
    id: 'type',
    header: 'Type',
    minSize: 90,
    size: 100,
    meta: { truncate: false },
    cell: () => 'Type',
  }),
  col.display({
    id: 'washHub',
    header: 'Wash Hub',
    minSize: 120,
    size: 150,
    meta: { truncate: false },
    cell: () => 'Wash Hub',
  }),
  col.display({
    id: 'status',
    header: 'Status',
    minSize: 90,
    size: 100,
    meta: { truncate: false },
    cell: () => 'Status',
  }),
  col.display({
    id: 'sites',
    header: 'Sites',
    minSize: 90,
    size: 100,
    meta: { truncate: false },
    cell: () => 'Sites',
  }),
  col.display({
    id: 'date',
    header: 'Date',
    minSize: 110,
    size: 130,
    meta: { truncate: false },
    cell: () => 'Date',
  }),
  col.display({
    id: 'contact',
    header: 'Contact',
    minSize: 110,
    size: 130,
    meta: { truncate: false },
    cell: () => 'Contact',
  }),
];
